<script setup lang="ts">
// Vendor
import { warn } from "vue";
import { string } from "zod";

const GRID_TEMPLATE_VALIDATOR = string().regex(
  /^((\d+fr|\d+px|\d+%|auto|min-content|max-content|fit-content\(\d+(px|%)\)|repeat\(\d+, (\d+fr|\d+px|\d+%)\))(\s+)?)+$/,
);

const { template = "1fr" } = defineProps<{
  template?: CSSStyleDeclaration["gridTemplateColumns"];
}>();

if (template && !GRID_TEMPLATE_VALIDATOR.safeParse(template).success) {
  warn(`[FormRow]: Invalid grid template: ${template}`);
}
</script>

<template>
  <div class="form-row">
    <slot />
  </div>
</template>

<style scoped lang="scss">
@use "@citizenm/lobby/assets/styles/utils/mixins" as mixins;

.form-row {
  display: grid;
  gap: var(--form-row-gap, 16px) var(--form-column-gap, 16px);
  margin-block: var(--form-row-gap, 16px);
  max-width: 100%;

  @include mixins.md {
    grid-template-columns: v-bind("template");
  }
}
</style>
